"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RepositoryBase = void 0;

var graphql_request_1 = require("graphql-request");

var LegalizeSDKError_1 = __importDefault(require("../../core/utilities/LegalizeSDKError"));

var enums_1 = require("../../enums");

var RepositoryBase =
/** @class */
function () {
  function RepositoryBase(baseUrl) {
    this.client = new graphql_request_1.GraphQLClient(baseUrl || "");
  }

  RepositoryBase.prototype.setBaseUrl = function (baseUrl) {
    this.client = new graphql_request_1.GraphQLClient(baseUrl);
  };

  RepositoryBase.prototype.setHeader = function (key, value) {
    this.client.setHeader(key, value);
  };

  RepositoryBase.prototype.request = function (query, variables) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      return _this.client.request(query, variables || {}).then(resolve).catch(function (error) {
        return reject(error.response ? new LegalizeSDKError_1.default("GQL error", error.response, enums_1.LegalizeSDKErrorType.GQL_ERROR) : new LegalizeSDKError_1.default("Unknown error", error, enums_1.LegalizeSDKErrorType.INTERNAL_SERVER_ERROR));
      });
    });
  };

  return RepositoryBase;
}();

exports.RepositoryBase = RepositoryBase;